module.exports = new __parcel__URL__("all-tickets.e438cf2e.svg").toString();